import { api } from "../../../../api/Middleware";
import {
  PIPELINE_AUTOMATIONS_URL,
  PIPELINE_AUTOMATIONS_TOGGLE_URL,
} from "../../../../api/Urls";

export const getAutomations = async (pipelineId) => {
  const params = {};
  if (pipelineId) params.pipeline = pipelineId;
  const response = await api.get(PIPELINE_AUTOMATIONS_URL, { params });
  return response.data;
};

export const getAutomation = async (id) => {
  const response = await api.get(`${PIPELINE_AUTOMATIONS_URL}${id}/`);
  return response.data;
};

export const createAutomation = async (data) => {
  const response = await api.post(PIPELINE_AUTOMATIONS_URL, data);
  return response.data;
};

export const updateAutomation = async (id, data) => {
  const response = await api.patch(`${PIPELINE_AUTOMATIONS_URL}${id}/`, data);
  return response.data;
};

export const deleteAutomation = async (id) => {
  const response = await api.delete(`${PIPELINE_AUTOMATIONS_URL}${id}/`);
  return response.data;
};

export const toggleAutomation = async (id) => {
  const response = await api.post(PIPELINE_AUTOMATIONS_TOGGLE_URL(id));
  return response.data;
};
